import { createSelector } from '@ngrx/store';
import { DateTime } from 'luxon';

import { User } from '@apps/auth/domain/models/back';
import { Comparer } from '@common/services';

import { getBackAuthUsersState } from '../users.selectors';
import { IBackAuthUsersState } from '../users.state';
import { usersAdapter } from '../users.common';
import { BackAuthUsersExternalFeatureKey, IBackAuthUsersExternalState } from './users-external.reducer';
import { filterQuickSearch } from '@common/services/utils.service';
import { BackConstants } from '@apps/back/back.constants';

export const getBackAuthUsersExternalState = createSelector(
    getBackAuthUsersState,
    (state: IBackAuthUsersState) =>
        state[BackAuthUsersExternalFeatureKey]
);

export const getUsersExternalCounters = createSelector(
    getBackAuthUsersExternalState,
    (state: IBackAuthUsersExternalState) =>
        state.counters
);

export const getUsersExternalQueryString = createSelector(
    getBackAuthUsersExternalState,
    (state: IBackAuthUsersExternalState) =>
        state.oData.qs
);
export const getBackAuthExternalUsersState = createSelector(
    getBackAuthUsersExternalState,
    (state: IBackAuthUsersExternalState) =>
        state.users
);
export const {
    selectAll: getAllUsersExternal,
    selectTotal: getTotalExternalUsers,
} = usersAdapter.getSelectors(getBackAuthExternalUsersState);
const getUsersExternalActive = createSelector(
    getAllUsersExternal,
    (users) =>
        users.filter((user: User) => user.active)
);
const getQuickSearchedUsersExternal = createSelector(
    getBackAuthUsersExternalState,
    getAllUsersExternal,
    (state: IBackAuthUsersExternalState, users: User[]) =>
        filterQuickSearch(users, state.qsWord, BackConstants.usersQSFields)
);
export const getPipelinedUsersExternal = createSelector(
    getQuickSearchedUsersExternal,
    (users: User[], params: { comparer: Comparer<User> }) =>
        [...users].sort(params.comparer)
);
// export const getEntityExternalUsers = createSelector(
//     getPipelinedEntityUsersImpe,
//     (users: User[], { id }: { id: string }) =>
//         users.filter((u: User) =>
//             u.entityId === id
//         )
// );
export const getUsersExternalLoadingStatus = createSelector(
    getBackAuthUsersExternalState,
    (state) =>
        state.isLoading
);
export const getUsersExternalLoadedStatus = createSelector(
    getBackAuthUsersExternalState,
    (state) =>
        state.isLoaded
);
export const getUsersExternalOupsStatus = createSelector(
    getBackAuthUsersExternalState,
    (state) =>
        state.isOups
);
export const getUsersExternalEmptyStatus = createSelector(
    getBackAuthUsersExternalState,
    (state) =>
        state.isEmpty
);
export const getUsersExternalIsDataValid = createSelector(
    getBackAuthUsersExternalState,
    (state) =>
        state.expirationDate !== null && DateTime.utc() < state.expirationDate
);
